export function getRegionIds(goals) {
    let regionIds = [];


    goals.forEach((goal) => {
        let regions = goal.goal.traffic_restrictions.regions ? goal.goal.traffic_restrictions.regions : [];
        regionIds = [...regionIds, ...regions];
    });

    return regionIds.join(',');
}

export function removeParams() {
    return {
        created_at_from: undefined,
        created_at_to: undefined,
        type: undefined,
        tab: undefined,
        nameLink: undefined
    };
};
